export default {
  LANG_CODE: 'de',
  LANG_NOT_FOUND: 'Wir unterstützen die Sprache, die Sie auswählen möchten, derzeit nicht.',
  LANG_HAS_DELETED: 'Zurzeit unterstützen wir die gelöschte Sprache nicht, bitte wenden Sie sich an unser Support-Team.',
  USER_ID: 'Benutzer-ID',
  USER_NAME: 'Benutzername',
  PASSWORD: 'Passwort',
  REQUIRED_FIELD: 'ist ein Pflichtfeld',
  FORGOT_PASSWORD: 'Passwort vergessen',
  API_DEFAULT_ERROR: 'Etwas ging schief, bitte versuchen Sie es nach einiger Zeit erneut',
  SUPPORT_LABEL: 'für Login- oder Passwortprobleme wenden Sie sich an',
  BACK_TO_LOGIN: 'Zurück zum Login',
  SUBMIT: 'Senden',
  YES: 'Ja',
  NO: 'Nein',
  DELETE: 'Löschen',
  LOGOUT: 'Ausloggen',
  LOGOUT_POPUP_TITLE: 'Möchten Sie sich abmelden?',
  EVENT_INFO: 'Veranstaltungsinfo',
  QUALIFYING_QUESTIONS: 'Qualifizierungsfragen',
  CONTENT: 'Inhalt',
  EMAILS: 'E-Mails',
  PREVIOUS: 'Zurück',
  CONTINUE: 'Fortfahren',
  FINISH: 'Fertigstellen',
  ADD: 'Hinzufügen',
  CANCEL: 'Abbrechen',
  APPROVE: 'Genehmigen',
  INVALID_FIELD: 'Dieses Feld ist ungültig',
  SET: 'Festlegen',
  EXHIBITORS: 'Aussteller',
  EVENT_ID: 'Ereignis-ID',
  PASS_MIN_LEN_ERROR: 'muss mindestens 6 Zeichen enthalten.',
  SAVE: 'Speichern',
  EDIT: 'Bearbeiten',
  COOCKIE_POLICY: 'Cookie-Richtlinie',
  COOCKIE_TEXT:
    'Cookies helfen uns bei der Bereitstellung unserer Dienste. Wir verwenden technische Cookies, um Ihnen das beste Erlebnis unserer Website zu bieten. Wenn Sie dieses Fenster schließen oder die Website weiter nutzen, erklären Sie sich mit der Verwendung solcher Cookies durch uns einverstanden. Erfahre mehr in unserem',
  COOCKIE_POLICY_LINK: 'https://fielddrive.com/cookie-policy/',
  SUCCESS_TITLE: 'Erfolgreich!',
  FAILED_TITLE: 'Gescheitert!',
  OR: 'Oder',
  EVENT_SETTINGS: 'Ereigniseinstellungen',
  LEADS: 'Führt',
  COPIED: 'Copied!',
  PREVIEW: 'Preview',
  RENAME: 'Rename',
  DELETE_LABEL: 'Möchten Sie diese löschen'
}
